<template>
  <!-- <component v-if="config" :is="config.site_config.configValue.pc_head_template" /> -->
  <component v-if="appConfig" :is="temp||'default1'" />
</template>
<script>
export default {
  components: {
    default1: () => import('~/template/home/default1'),
    dfcp: () => import('~/template/home/dfcp'),
  },
  computed: {
    appConfig(){
      return this.$store.state.service.appConfig;
    },
    temp(){
      if(this.appConfig.hasOwnProperty('index')){
        return this.appConfig.index
      }else{
        return 'dfcp'
      }
    }
  },
  methods: {}
}
</script>

<style lang="less">
</style>
